import { DropDownView, FilterType } from '@gripp/shared-ui';
import { View } from 'react-native';
import { RoutineFilter } from './routineFilter';

type RoutineFilterMenuProps = {
  onRoutineFilterOpen: () => void;
  onRoutineFilterClose: () => void;
  isOpened: boolean;
  anchorRef: React.RefObject<View>;
  type: FilterType;
};

export const RoutineFilterMenu = ({
  onRoutineFilterClose,
  onRoutineFilterOpen,
  isOpened,
  anchorRef,
  type,
}: RoutineFilterMenuProps) => {
  return (
    <DropDownView
      anchorRef={anchorRef}
      isVisible={isOpened}
      onDismiss={onRoutineFilterClose}
    >
      <RoutineFilter onCloseSideBar={onRoutineFilterClose} type={type} />
    </DropDownView>
  );
};
